import * as React from "react";
import DeviceInfo from "./DeviceInfo";
import DeviceVoting from "./DeviceVoting";
import { DeviceData } from "../models/DeviceData";
import Device from "./Device";
import { ProtectiveFunctionLocation } from "../models/protectiveFunctionLocation";
import EmptyDevicePosition from "./EmptyDevicePosition";
import { isMooNVotingType, parseMooNVoting, IMooN } from "./../helpers";
import { Message, MessageTemplateType } from "../models/ProtectiveFunctionWrapper";
import { MasterPoolMismatchItem } from "../models/MasterPoolMismatchItem";

interface Props {
    zoom: number;
    location: ProtectiveFunctionLocation;
    voting?: string;
    devices: Array<DeviceData>;
    handleDeviceClicked: (device: DeviceData, type: string) => void;
    onConfigVotingClicked: (location: ProtectiveFunctionLocation, voting: string) => void;
    handleConfigurationClicked: (e: React.MouseEvent, location: ProtectiveFunctionLocation, devices: Array<DeviceData>) => void;
    handleDeviceRightClicked: (e: React.MouseEvent, device: DeviceData) => void;
    handleEmptyDeviceLocationClick: (position: string, location: ProtectiveFunctionLocation, voting: string) => void;
    onEmptyDeviceLocationRightClick: (e: React.MouseEvent, deviceLocation: string, configLocation: ProtectiveFunctionLocation) => void;
    errorsAndWarnings: Message[];
    inputConfigurationName: string;
    masterPoolMismatchItems?: MasterPoolMismatchItem[];
}

export class InputConfiguration extends React.Component<Props, {}> {
    constructor(props: Props) {
        super(props);
    }

    zoom(value: number, unit: "px" | "em") {
        return `${value * this.props.zoom}${unit}`;
    }

    handleConfigVotingClicked = (e: React.MouseEvent) => {
        this.props.onConfigVotingClicked(this.props.location, this.props.voting); 
    }
  
    render() {
        const location = this.props.location;
        const devices = this.props.devices;
        const handleDeviceRightClicked = this.props.handleDeviceRightClicked;
        const handleDeviceClicked = this.props.handleDeviceClicked;
        const zoom = this.props.zoom;
        const boxSize = this.zoom(50, "px");
        const imgWidth = this.zoom(41, "px");
        const imgHeight = this.zoom(40, "px");
        const votingWidth = this.zoom(50, "px");
        const votingHeight = this.zoom(20, "px");
        const channel1X = this.zoom(3, "px");
        const channel2X = this.zoom(128, "px");
        const channel3X = this.zoom(256, "px");
        const row1Y = this.zoom(4, "px");
        const row2Y = this.zoom(70, "px");
        const row3Y = this.zoom(138, "px");
        const fontSize = this.zoom(.9, "em");
        const deviceInfoChannel1X = this.zoom(-80, "px");
        const deviceInfoChannel2X = this.zoom(46, "px");
        const deviceInfoChannel3X = this.zoom(172, "px");
        const deviceInfoRow1Y = this.zoom(-18, "px");
        const deviceInfoRow2Y = this.zoom(55, "px");
        const deviceInfoRow3Y = this.zoom(130, "px");
        const deviceVoting1X = this.zoom(4, "px");
        const deviceVoting2X = this.zoom(130, "px");
        const deviceVoting3X = this.zoom(255, "px");
        const deviceVoting1Y = this.zoom(37, "px");
        const deviceVoting2Y = this.zoom(105, "px");
        const deviceVoting3Y = this.zoom(174, "px");
        const div = `div${this.props.location[this.props.location.length - 1]}`
        
        const positionMap: {
            [devicePosition: string]:
            {
                deviceData: DeviceData;
                errorsAndWarnings: Message[]
            }
        } = {};
        for (let device of this.props.devices) {
            const pt = device.ptProtectiveFunction;
            if (pt.devicePosition != null) {
                var errorsAndWarnings: Message[] = [];
                if (this.props.errorsAndWarnings) {
                    errorsAndWarnings = this.props.errorsAndWarnings.filter(x => x.messageItems ? x.messageItems.some(c => c.id === pt.protectiveFunctionID) && x.messageTemplateType != MessageTemplateType.EnsureNoBlankChannels : false);
                }

                positionMap[pt.devicePosition.trim()] = {
                    deviceData: device,
                    errorsAndWarnings: errorsAndWarnings
                };
            }            
        }

        var hasWarning = false;
        var hasError = false;
        var CCFEErrorsAndWarningsText = "";
        if (this.props.errorsAndWarnings) {
            const CCFErrorsAndWarnings = this.props.errorsAndWarnings.filter(x => x.messageItems ? x.messageItems.some(c => c.id === this.props.inputConfigurationName) && x.messageTemplateType != MessageTemplateType.EnsureNoBlankChannels : false);

            if (CCFErrorsAndWarnings.length) {
                hasWarning = CCFErrorsAndWarnings.some(x => x.messageType === 'warning');
                hasError = CCFErrorsAndWarnings.some(x => x.messageType === 'error');
                CCFEErrorsAndWarningsText = CCFErrorsAndWarnings.map(x => x.formatMessageById(this.props.inputConfigurationName)).join('\n');
            }
        }

        const handleEmptyDeviceLocationClick = this.props.handleEmptyDeviceLocationClick;
        var voting = this.props.voting.trim();
        var parsedVoting = parseMooNVoting(voting);

        return (
            <div className="Complex3oo3-0">
                {/* Channel 3 */}
                {positionMap["D31"] != null ? 
                    <div>
                        <DeviceInfo x={deviceInfoChannel1X} y={deviceInfoRow1Y} fontSize={fontSize} device={positionMap["D31"].deviceData} />
                        <Device masterPoolMismatchItems={this.props.masterPoolMismatchItems} type={"Device"} x={channel1X} y={row1Y} boxSize={boxSize} imgWidth={imgWidth} imgHeight={imgHeight} errorsAndWarnings={positionMap["D31"].errorsAndWarnings} device={positionMap["D31"].deviceData} handleDeviceClicked={handleDeviceClicked} handleDeviceRightClicked={handleDeviceRightClicked} />
                        <DeviceVoting x={deviceVoting1X} y={deviceVoting1Y} votingWidth={votingWidth} votingHeight={votingHeight} device={positionMap["D31"].deviceData} />
                    </div>
                    :
                    <div>
                        {voting === "1oo2" || voting === "2oo2" || voting === "1oo3" || voting === "2oo3" || voting === "3oo3" ?
                            <EmptyDevicePosition
                                errorsAndWarnings={this.props.errorsAndWarnings}
                                configurationName={this.props.inputConfigurationName}
                                devicePosition="D31"
                                location={this.props.location}
                                voting={this.props.voting}
                                diagramPosition={{ top: row1Y, left: channel1X }}
                                size={{ height: boxSize, width: boxSize }}
                                backgroundColor="rgb(0,0,255,0)"
                                onClick={handleEmptyDeviceLocationClick}
                                onRightClick={this.props.onEmptyDeviceLocationRightClick} />
                            :
                            null
                        }
                    </div>
                }
                {positionMap["D32"] != null ?
                    <div>
                        <DeviceInfo x={deviceInfoChannel1X} y={deviceInfoRow2Y} fontSize={fontSize} device={positionMap["D32"].deviceData} />
                        <Device masterPoolMismatchItems={this.props.masterPoolMismatchItems} type={"Device"} x={channel1X} y={row2Y} boxSize={boxSize} imgWidth={imgWidth} imgHeight={imgHeight} errorsAndWarnings={positionMap["D32"].errorsAndWarnings} device={positionMap["D32"].deviceData} handleDeviceClicked={handleDeviceClicked} handleDeviceRightClicked={handleDeviceRightClicked} />
                        <DeviceVoting x={deviceVoting1X} y={deviceVoting2Y} votingWidth={votingWidth} votingHeight={votingHeight} device={positionMap["D32"].deviceData} />
                    </div>
                    :
                    <div>
                        {voting === "1oo2" || voting === "2oo2" || voting === "1oo3" || voting === "2oo3" || voting === "3oo3" ?
                            <EmptyDevicePosition
                                errorsAndWarnings={this.props.errorsAndWarnings}
                                configurationName={this.props.inputConfigurationName}
                                devicePosition="D32"
                                location={this.props.location}
                                voting={this.props.voting}
                                diagramPosition={{ top: row2Y, left: channel1X }}
                                size={{ height: boxSize, width: boxSize }}
                                backgroundColor="rgb(255,0,0,0)"
                                onClick={handleEmptyDeviceLocationClick}
                                onRightClick={this.props.onEmptyDeviceLocationRightClick}
                            />
                            :
                            null
                        }
                    </div>
                }                
                {positionMap["D33"] != null ?
                    <div>
                        <DeviceInfo x={deviceInfoChannel1X} y={deviceInfoRow3Y} fontSize={fontSize} device={positionMap["D33"].deviceData} />
                        <Device masterPoolMismatchItems={this.props.masterPoolMismatchItems} type={"Device"} x={channel1X} y={row3Y} boxSize={boxSize} imgWidth={imgWidth} imgHeight={imgHeight} errorsAndWarnings={positionMap["D33"].errorsAndWarnings} device={positionMap["D33"].deviceData} handleDeviceClicked={handleDeviceClicked} handleDeviceRightClicked={handleDeviceRightClicked} />
                        <DeviceVoting x={deviceVoting1X} y={deviceVoting3Y} votingWidth={votingWidth} votingHeight={votingHeight} device={positionMap["D33"].deviceData} />
                    </div>
                    :
                    <div>
                        {voting === "Device1oo2" || voting === "Device2oo2" || voting === "Device1oo3" || voting === "Device2oo3" || voting === "Device3oo3" || voting === "1oo2" || voting === "2oo2" || voting === "1oo3" || voting === "2oo3" || voting === "3oo3" ?
                            <EmptyDevicePosition
                                errorsAndWarnings={this.props.errorsAndWarnings}
                                configurationName={this.props.inputConfigurationName}
                                devicePosition="D33"
                                location={this.props.location}
                                voting={this.props.voting}
                                diagramPosition={{ top: row3Y, left: channel1X }}
                                size={{ height: boxSize, width: boxSize }}
                                backgroundColor="rgb(255,255,0,0)"
                                onClick={handleEmptyDeviceLocationClick}
                                onRightClick={this.props.onEmptyDeviceLocationRightClick}
                            />
                            :
                            null
                        }
                    </div>
                }
                {/* Channel 2 */}
                {positionMap["D21"] != null ?
                    <div>
                        <DeviceInfo x={deviceInfoChannel2X} y={deviceInfoRow1Y} fontSize={fontSize} device={positionMap["D21"].deviceData} />
                        <Device masterPoolMismatchItems={this.props.masterPoolMismatchItems} type={"Device"} x={channel2X} y={row1Y} boxSize={boxSize} imgWidth={imgWidth} imgHeight={imgHeight} errorsAndWarnings={positionMap["D21"].errorsAndWarnings} device={positionMap["D21"].deviceData} handleDeviceClicked={handleDeviceClicked} handleDeviceRightClicked={handleDeviceRightClicked} />
                        <DeviceVoting x={deviceVoting2X} y={deviceVoting1Y} votingWidth={votingWidth} votingHeight={votingHeight} device={positionMap["D21"].deviceData} />
                    </div>
                    :
                    <div>
                        {voting === "1oo1" || voting === "1oo3" || voting === "2oo3" || voting === "3oo3" ?
                            <EmptyDevicePosition
                                errorsAndWarnings={this.props.errorsAndWarnings}
                                configurationName={this.props.inputConfigurationName}
                                devicePosition="D21"
                                location={this.props.location}
                                voting={this.props.voting}
                                diagramPosition={{ top: row1Y, left: channel2X }}
                                size={{ height: boxSize, width: boxSize }}
                                backgroundColor="rgb(0,0,255,0)"
                                onClick={handleEmptyDeviceLocationClick}
                                onRightClick={this.props.onEmptyDeviceLocationRightClick}
                            />
                            :
                            null
                        }
                    </div>
                }
                {positionMap["D22"] != null ?
                    <div>
                        <DeviceInfo x={deviceInfoChannel2X} y={deviceInfoRow2Y} fontSize={fontSize} device={positionMap["D22"].deviceData} />
                        <Device masterPoolMismatchItems={this.props.masterPoolMismatchItems} type={"Device"} x={channel2X} y={row2Y} boxSize={boxSize} imgWidth={imgWidth} imgHeight={imgHeight} errorsAndWarnings={positionMap["D22"].errorsAndWarnings} device={positionMap["D22"].deviceData} handleDeviceClicked={handleDeviceClicked} handleDeviceRightClicked={handleDeviceRightClicked} />
                        <DeviceVoting x={deviceVoting2X} y={deviceVoting2Y} votingWidth={votingWidth} votingHeight={votingHeight} device={positionMap["D22"].deviceData} />
                    </div>
                    :
                    <div>
                        {voting === "1oo1" || voting === "1oo3" || voting === "2oo3" || voting === "3oo3" ?
                            <EmptyDevicePosition
                                errorsAndWarnings={this.props.errorsAndWarnings}
                                configurationName={this.props.inputConfigurationName}
                                devicePosition="D22"
                                location={this.props.location}
                                voting={this.props.voting}
                                diagramPosition={{ top: row2Y, left: channel2X }}
                                size={{ height: boxSize, width: boxSize }}
                                backgroundColor="rgb(255,0,0,0)"
                                onClick={handleEmptyDeviceLocationClick}
                                onRightClick={this.props.onEmptyDeviceLocationRightClick}
                            />
                            :
                            null
                        }
                    </div>
                }
                {positionMap["D23"] != null ? 
                    <div>
                        <DeviceInfo x={deviceInfoChannel2X} y={deviceInfoRow3Y} fontSize={fontSize} device={positionMap["D23"].deviceData} />
                        <Device masterPoolMismatchItems={this.props.masterPoolMismatchItems} type={"Device"} x={channel2X} y={row3Y} boxSize={boxSize} imgWidth={imgWidth} imgHeight={imgHeight} errorsAndWarnings={positionMap["D23"].errorsAndWarnings} device={positionMap["D23"].deviceData} handleDeviceClicked={handleDeviceClicked} handleDeviceRightClicked={handleDeviceRightClicked} />
                        <DeviceVoting x={deviceVoting2X} y={deviceVoting3Y} votingWidth={votingWidth} votingHeight={votingHeight} device={positionMap["D23"].deviceData} />
                    </div>
                    :
                    <div>
                        {voting === "Device1oo1" || voting === "Device1oo3" || voting === "Device2oo3" || voting === "Device3oo3" || voting === "1oo1" || voting === "1oo3" || voting === "2oo3" || voting === "3oo3" ?
                            <EmptyDevicePosition
                                errorsAndWarnings={this.props.errorsAndWarnings}
                                configurationName={this.props.inputConfigurationName}
                                devicePosition="D23"
                                location={this.props.location}
                                voting={this.props.voting}
                                diagramPosition={{ top: row3Y, left: channel2X }}
                                size={{ height: boxSize, width: boxSize }}
                                backgroundColor="rgb(255,255,0,0)"
                                onClick={handleEmptyDeviceLocationClick}
                                onRightClick={this.props.onEmptyDeviceLocationRightClick}
                            />
                            :
                            null
                        }
                    </div>
                }
                {/* Channel 1 */}
                {positionMap["D11"] != null ?
                    <div>
                        <DeviceInfo x={deviceInfoChannel3X} y={deviceInfoRow1Y} fontSize={fontSize} device={positionMap["D11"].deviceData} />
                        <Device masterPoolMismatchItems={this.props.masterPoolMismatchItems} type={"Device"} x={channel3X} y={row1Y} boxSize={boxSize} imgWidth={imgWidth} imgHeight={imgHeight} errorsAndWarnings={positionMap["D11"].errorsAndWarnings} device={positionMap["D11"].deviceData} handleDeviceClicked={handleDeviceClicked} handleDeviceRightClicked={handleDeviceRightClicked} />
                        <DeviceVoting x={deviceVoting3X} y={deviceVoting1Y} votingWidth={votingWidth} votingHeight={votingHeight} device={positionMap["D11"].deviceData} />
                    </div>
                    :
                    <div>
                        {voting === "1oo2" || voting === "2oo2" || voting === "1oo3" || voting === "2oo3" || voting === "3oo3"  || isMooNVotingType(this.props.voting) ?
                            <EmptyDevicePosition
                                errorsAndWarnings={this.props.errorsAndWarnings}
                                configurationName={this.props.inputConfigurationName}
                                devicePosition="D11"
                                location={this.props.location}
                                voting={this.props.voting}
                                diagramPosition={{ top: row1Y, left: channel3X }}
                                size={{ height: boxSize, width: boxSize }}
                                backgroundColor="rgb(0,0,255,0)"
                                onClick={handleEmptyDeviceLocationClick}
                                onRightClick={this.props.onEmptyDeviceLocationRightClick}
                            />
                            :
                            null
                        }
                    </div>
                }
                {positionMap["D12"] != null ?
                    <div>
                        <DeviceInfo x={deviceInfoChannel3X} y={deviceInfoRow2Y} fontSize={fontSize} device={positionMap["D12"].deviceData} />
                        <Device masterPoolMismatchItems={this.props.masterPoolMismatchItems} type={"Device"} x={channel3X} y={row2Y} boxSize={boxSize} imgWidth={imgWidth} imgHeight={imgHeight} errorsAndWarnings={positionMap["D12"].errorsAndWarnings} device={positionMap["D12"].deviceData} handleDeviceClicked={handleDeviceClicked} handleDeviceRightClicked={handleDeviceRightClicked} />
                        <DeviceVoting x={deviceVoting3X} y={deviceVoting2Y} votingWidth={votingWidth} votingHeight={votingHeight} device={positionMap["D12"].deviceData} />
                    </div>
                    :
                    <div>
                        {voting === "1oo2" || voting === "2oo2" || voting === "1oo3" || voting === "2oo3" || voting === "3oo3"  || isMooNVotingType(this.props.voting) ?
                            <EmptyDevicePosition
                                errorsAndWarnings={this.props.errorsAndWarnings}
                                configurationName={this.props.inputConfigurationName}
                                devicePosition="D12"
                                location={this.props.location}
                                voting={this.props.voting}
                                diagramPosition={{ top: row2Y, left: channel3X }}
                                size={{ height: boxSize, width: boxSize }}
                                backgroundColor="rgb(255,0,0,0)"
                                onClick={handleEmptyDeviceLocationClick}
                                onRightClick={this.props.onEmptyDeviceLocationRightClick}
                            />
                            :
                            null
                        }
                    </div>
                }
                {positionMap["D13"] != null ?
                    <div>
                        <DeviceInfo x={deviceInfoChannel3X} y={deviceInfoRow3Y} fontSize={fontSize} device={positionMap["D13"].deviceData} />
                        <Device masterPoolMismatchItems={this.props.masterPoolMismatchItems} type={"Device"} x={channel3X} y={row3Y} boxSize={boxSize} imgWidth={imgWidth} imgHeight={imgHeight} errorsAndWarnings={positionMap["D13"].errorsAndWarnings} device={positionMap["D13"].deviceData} handleDeviceClicked={handleDeviceClicked} handleDeviceRightClicked={handleDeviceRightClicked} />
                        <DeviceVoting x={deviceVoting3X} y={deviceVoting3Y} votingWidth={votingWidth} votingHeight={votingHeight} device={positionMap["D13"].deviceData} />
                    </div>
                    :
                    <div>
                        {voting === "Device1oo2" || voting === "Device2oo2" || voting === "Device1oo3" || voting === "Device2oo3" || voting === "Device3oo3" || voting === "1oo2" || voting === "2oo2" || voting === "1oo3" || voting === "2oo3" || voting === "3oo3" || isMooNVotingType(this.props.voting) ?
                            <EmptyDevicePosition
                                errorsAndWarnings={this.props.errorsAndWarnings}
                                configurationName={this.props.inputConfigurationName}
                                devicePosition="D13"
                                location={this.props.location}
                                voting={this.props.voting}
                                diagramPosition={{ top: row3Y, left: channel3X }}
                                size={{ height: boxSize, width: boxSize }}
                                backgroundColor="rgb(255,255,0,0)"
                                onClick={handleEmptyDeviceLocationClick}
                                onRightClick={this.props.onEmptyDeviceLocationRightClick}
                            />
                            :
                            null
                        }
                    </div>
                }
                {/* Background */}
                {this.props.voting ? 
                  isMooNVotingType(this.props.voting) ? <img style={{ width: `${300 * zoom}px`, height: `${300 * zoom}px` }} src={`/HTMLImages/Image/MooNInputConfig.png`} />
                  : <img style={{ width: `${300 * zoom}px`, height: `${300 * zoom}px` }} src={`/HTMLImages/Image/${this.props.voting}.png`} /> 
                  : null}
            {this.props.voting && isMooNVotingType(this.props.voting) &&
              <div style={{ position: 'absolute', right: '50px', bottom: '19px', fontSize: '0.45em' }}>
                <span className="label_device">M: {parsedVoting.M}</span>
                <span className="label_device">N: {parsedVoting.N}</span>                
              </div>
            }
            <div id={this.props.location} title={CCFEErrorsAndWarningsText} className={`input-configuration-ccf ${hasWarning ? "warning-message" : ""} ${hasError ? "error-message" : ""}`} style={{ zIndex: 100, backgroundColor: "rgb(0,255,0,0)", height: `${73 * zoom}px`, width: `${73 * zoom}px`, position: "absolute", marginTop: `${-90 * zoom}px`, marginLeft: `${115 * zoom}px`, pointerEvents: "all" }} onClick={this.handleConfigVotingClicked} ></div>
            <div id={div} style={{ zIndex: 10, backgroundColor: "rgb(220,220,220,0)", height: `${300 * zoom}px`, width: `${350 * zoom}px`, position: "absolute", top: `${0 * zoom}px`, left: `${0 * zoom}px`, pointerEvents: "all" }} onContextMenu={(e: React.MouseEvent) => this.props.handleConfigurationClicked(e, this.props.location, devices)} ></div>
            </div>
        );
    }
}